export const customerFullName = (c) => `${c.firstName || ''} ${c.lastName || ''}`.trim();

export const matchesCustomer = (c, query) => {
  const q = (query || '').trim().toLowerCase();
  if (!q) return true;
  if (/^#?\d+$/.test(q) && String(c.customerNumber) === q.replace('#', '')) return true;
  return customerFullName(c).toLowerCase().includes(q);
};

export const buildNumberLookup = (customers = []) => {
  const map = {};
  customers.forEach((c) => { if (c.customerNumber) map[customerFullName(c).toLowerCase()] = c.customerNumber; });
  return (name) => map[(name || '').trim().toLowerCase()];
};
